// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","with_bottom_margin":"_3lQ0FzL","label":"_3gDCo3I"};